<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-页面列表
  -->
  <div class="user">
    <!--添加页面-->
    <div class="common-level-rail">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addClick()"
        v-auth="'/page/tabbar/add'"
        >添加页面</el-button
      >
    </div>
    <el-form
      size="small"
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
    >
      <el-form-item label="关键词"
        ><el-input
          size="small"
          v-model="searchForm.title"
          placeholder="关键词搜索"
        ></el-input
      ></el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column
            prop="page_id"
            label="页面ID"
            width="80"
          ></el-table-column>
          <el-table-column prop="page_name" label="页面名称">
            <template slot-scope="scope">
              <span>{{ scope.row.page_name }}</span>
              <!-- <span class="gray">（首页）</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="page_type" label="页面类型">
            <template slot-scope="scope">
              <span v-if="scope.row.page_type == 10">商城首页</span>
              <span v-if="scope.row.page_type == 20">自定义页</span>
              <span v-if="scope.row.page_type == 30">用户中心</span>
              <span v-if="scope.row.page_type == 40">底部菜单</span>
              <span v-if="scope.row.page_type == 50">官网</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="添加时间"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column prop="is_default" label="设为默认">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.is_default"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="isDefaultChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.page_type != 40"
                @click="openPopup(scope.row, 'diypage')"
                type="text"
                size="small"
                >页面链接</el-button
              >
              <el-button
                @click="editClick(scope.row.page_id)"
                type="text"
                size="small"
                v-auth="'/page/tabbar/edit'"
                >编辑</el-button
              >
              <el-button
                v-if="!scope.row.is_default"
                @click="deleteClick(scope.row.page_id)"
                type="text"
                size="small"
                v-auth="'/page/page/delete'"
                >删除
              </el-button>
              <el-button
                @click="copyPage(scope.row.page_id)"
                type="text"
                size="small"
                v-auth="'/page/tabbar/copy'"
                >一键复制</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        >
        </el-pagination>
      </div>
    </div>
    <!--页面链接-->
    <LinkPage
      v-if="show_path"
      :is_open="show_path"
      :path_type="path_type"
      :dataModel="dataModel"
      @closeDialog="closeDialogFunc($event, 'path')"
    ></LinkPage>
  </div>
</template>

<script>
import PageApi from "@/api/page.js";
import LinkPage from "@/components/page/path";
export default {
  components: {
    LinkPage
  },
  data() {
    return {
      path_type: "",
      show_path: false,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      wxapp_id: "",
      searchForm: {
        title: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*复制*/
    copyPage(page_id) {
      let self = this;
      self.loading = true;
      PageApi.editIndexPage({ page_id: page_id }, true)
        .then(res => {
          self.diyData = res.data.jsonData;
          let scene = "copy";

          PageApi.SavePage(
            {
              page_id: page_id,
              scene: scene,
              Parmens: self.diyData
            },
            true
          )
            .then(data => {
              self.loading = false;

              self.curPage = 1;
              self.getTableList();

              self.$message({
                message: "恭喜你，复制成功",
                type: "success"
              });
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openPopup(item, type) {
      this.dataModel = item;
      this.dataModel.wxapp_id = this.wxapp_id;
      this.show_path = true;
      this.path_type = type;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "path") {
        this.show_path = e.openDialog;
      }
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.title = self.searchForm.title;
      Params.page_type = 40;
      PageApi.getIndexList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
      // PageApi.PageList(Params, true).then(data => {
      //   self.loading = false;
      //   self.tableData = data.data.list.data;
      //   self.wxapp_id = data.data.wxapp_id;
      //   self.totalDataNumber = data.data.list.total;
      // }).catch(error => {

      // });
    },
    /* 设置默认 */
    isDefaultChange(row) {
      let self = this;
      self
        .$confirm("是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          console.log(row.is_default);
          let is_defalut = 1;
          if (row.is_default) {
            is_defalut = 1;
          } else {
            is_defalut = 0;
          }
          self.loading = true;
          PageApi.setPageDefault(
            {
              page_id: row.page_id,
              type: 1,
              is_default: is_defalut,
              page_type: 40,
              role_id: row.role_id
            },
            true
          )
            .then(data => {
              console.log(data);
              if (data.code === 1) {
                self.loading = false;
                self.$message({
                  message: "恭喜你，操作成功",
                  type: "success"
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          row.is_default = !row.is_default;
        });
    },
    /*删除数据*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          PageApi.deletePage(
            {
              page_id: row
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.loading = false;
                self.$message({
                  message: "恭喜你，删除成功",
                  type: "success"
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },

    /*添加页面*/
    addClick() {
      this.$router.push("/page/tabbar/add");
    },

    /*设为首页*/
    setHomeClick(page_id) {
      let self = this;
      self
        .$confirm("确定要将此页面设置为默认首页吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          PageApi.setHome(
            {
              page_id: page_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，设置成功",
                  type: "success"
                });
                self.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },

    /*编辑*/
    editClick(page_id) {
      let self = this;
      self.$router.push({
        path: "/page/tabbar/edit",
        query: {
          page_id: page_id
        }
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/page/tabbar/index.vue